import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';

import WaveBanner from '../../elements/wave-banner';
import CollectionCards from '../../elements/collection-cards';
import VideoPlayer from '../../elements/video-player';
import SimpleSplitSection from '../../elements/simple-split-section';
import IconSection from '../../elements/icon-section';
import BrandedCTA from './branded-cta';
import ContactForm from '../../elements/contact-form';

import { media } from '../../helpers';

const BrandedCategoryContainer = styled.div`
    .footer-form-container {
        margin-bottom: -5vh;
    }

    .cards-container {
        top: -10vh;
        margin-bottom: -10vh;

        position: relative;
        ${media.small`top: -15vh; margin-bottom: -15vh;`}
    }

    .video-outer-container {
        margin-bottom: 10vh;
    }
`;

const BrandedCategory = () => {
    const data = useStaticQuery(graphql`
        query {
            branded: allWpPage(filter: { title: { eq: "Branded Category" } }) {
                edges {
                    node {
                        branded_cat_acf {
                            brandedCta {
                                ctaDescription
                                ctaTitle
                                leftImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 1400) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                                rightImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 1400) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                                ctaButton {
                                    title
                                    url
                                }
                            }
                            brandedVideo {
                                videoCaption
                                videoSource
                                videoTitle
                                videoImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 1400) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                                videoLinkText
                            }
                            brandedBanner {
                                bannerBgColor
                                bannerCaption
                                bannerHeadline
                            }
                            brandedCardSection {
                                brandedCards {
                                    cardLink {
                                        target
                                        title
                                        url
                                    }
                                    # hoverText
                                    cardImage {
                                        localFile {
                                            childImageSharp {
                                                fluid(maxWidth: 700) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                    overlayColor
                                }
                                footerCaption
                                largeButton {
                                    title
                                    url
                                }
                                smallButton {
                                    title
                                    url
                                }
                            }
                            brandedIconSection {
                                icons {
                                    iconCaption
                                    iconImage {
                                        localFile {
                                            childImageSharp {
                                                fluid(maxWidth: 100) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                }
                                footerCaption
                                largeButton {
                                    title
                                    url
                                }
                                smallButton {
                                    target
                                    title
                                    url
                                }
                            }
                            brandedSplitSection1 {
                                contentRow {
                                    contentRowImage {
                                        localFile {
                                            childImageSharp {
                                                fluid(maxWidth: 1000) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                    contentRowDescription
                                    contentRowTitle
                                    contentRowLinks {
                                        link {
                                            target
                                            title
                                            url
                                        }
                                    }
                                }
                            }
                            brandedSplitSection2 {
                                contentRow {
                                    contentRowImage {
                                        localFile {
                                            childImageSharp {
                                                fluid(maxWidth: 1000) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                    contentRowDescription
                                    contentRowTitle
                                    contentRowLinks {
                                        link {
                                            target
                                            title
                                            url
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const page = data && data.branded.edges[0].node;
    const {
        brandedBanner,
        brandedCardSection,
        brandedSplitSection1,
        brandedSplitSection2,
        brandedVideo,
        brandedIconSection,
        brandedCta,
    } = page.branded_cat_acf || {};
    // console.log(page);
    return (
        <BrandedCategoryContainer>
            <WaveBanner content={brandedBanner} />
            <div className="cards-container">
                <CollectionCards
                    content={brandedCardSection}
                    cards={brandedCardSection.brandedCards}
                />
            </div>
            <div className="video-outer-container">
                <VideoPlayer content={brandedVideo} />
            </div>
            <SimpleSplitSection rows={brandedSplitSection1.contentRow} />
            <IconSection
                content={brandedIconSection}
                icons={brandedIconSection.icons}
            />
            <SimpleSplitSection rows={brandedSplitSection2.contentRow} />
            <BrandedCTA content={brandedCta} />
            <div className="footer-form-container">
                <ContactForm />
            </div>
        </BrandedCategoryContainer>
    );
};

export default BrandedCategory;
